export enum DeviceId {
  BlackBerry = 70,
  BlackBerryBold9000 = 75,
  CellPhone = 9,
  GamingConsole = 46,
  Google = 277,
  IPhone = 59,
  IPhone14 = 1537,
  Laptop = 11,
  Other = 1251,
  OtherChild = 1354,
  Samsung = 73,
  Tablet = 10,
}
